export default __webpack_public_path__ + "static/media/ukus.343c07b1.svg";